import classNames from "classnames"
import ApplicationComponent from "legacy/ApplicationComponent"
import AssignModal from "legacy/assignments/AssignModal"
import ColorLegend from "legacy/assignments/ColorLegend"
import PlaceholderModal from "legacy/assignments/PlaceholderModal"
import {
  afterSetState,
  boatDisplayText,
  inchesToFeet,
  isset,
} from "legacy/helpers.es6"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"

class AssignmentsController extends ApplicationComponent {
  constructor(props) {
    super(props)
    let reservationID = false
    if (isset(this.getURLParameter("reservation_id"))) {
      reservationID = this.getURLParameter("reservation_id")
    }
    this.state = {
      /* ajaxed in on mount */
      tableData: null,
      pendingAssignments: null,
      dateDetails: null,
      /* ------------------ */
      editReservationID: reservationID,
      editPlaceholder: null,
      night: this.props.night,
      marinaSlug: this.props.marinaSlug,
      modalMinimized: false,
      newPlaceholderForSpace: null,
      pageLastUpdated: moment(),
      pageLastUpdatedText: moment().fromNow(),
      initialLoad: true,
      errorLoadingData: null,
    }
    this.loadPageData = this.loadPageData.bind(this)
    this.loadSpaces = this.loadSpaces.bind(this)
    this.getAssignmentsOnNight = this.getAssignmentsOnNight.bind(this)
    this.lastUpdatedText = this.lastUpdatedText.bind(this)
    this.resetPageLastUpdated = this.resetPageLastUpdated.bind(this)
    this.editSpace = this.editSpace.bind(this)
    this.enterSpace = this.enterSpace.bind(this)
    this.leaveSpace = this.leaveSpace.bind(this)
    this.enterPlaceholder = this.enterPlaceholder.bind(this)
    this.leavePlaceholder = this.leavePlaceholder.bind(this)
    this.newPlaceholder = this.newPlaceholder.bind(this)
    this.editPlaceholder = this.editPlaceholder.bind(this)
    this.handleHideModal = this.handleHideModal.bind(this)
    this.handleHidePlaceholderModal = this.handleHidePlaceholderModal.bind(this)
    this.setGlobalState = this.setGlobalState.bind(this)
    this.initialLoad = this.initialLoad.bind(this)
    this.daysInRange = 8
    this.firstDay = moment(this.props.night)
      .subtract(2, "days")
      .format("YYYY-MM-DD")
    this.lastDay = moment(this.props.night).add(5, "days").format("YYYY-MM-DD")
    this.dateDetails = {}
    this.finishedDataFetch = false
    this.datePicker = null
    this.setDatePicker = (element) => {
      this.datePicker = element
    }
  }

  componentDidMount() {
    this.loadPageData()
  }

  loadPageData(closure = false) {
    this.setState({ errorLoadingData: null })
    $.get(
      `/manage/${this.state.marinaSlug}/assignments/unassigned_reservations?night=${this.state.night}`,
      (data) => {
        this.setState({ pendingAssignments: data })
        this.loadSpaces(closure)
      }
    ).fail((data) => {
      this.setState({ errorLoadingData: data.responseJSON })
    })
  }

  loadSpaces(closure) {
    this.setState({ errorLoadingData: null })
    $.get(
      "/manage/" + this.state.marinaSlug + "/assignments/spaces",
      (data) => {
        this.spaces = data
        this.getAssignmentsOnNight(closure, this.firstDay)
      }
    ).fail((data) => {
      this.setState({ errorLoadingData: data.responseJSON })
    })
  }

  getAssignmentsOnNight(closure, night) {
    this.setState({ errorLoadingData: null })
    $.get(
      "/manage/" +
        this.state.marinaSlug +
        "/assignments/assignments_and_placeholders?night=" +
        night,
      (data) => {
        this.spaces.forEach((space, index, array) => {
          if (_.has(array[index], "assignments") === false) {
            array[index].assignments = {}
            array[index].placeholders = []
          }
          array[index].assignments[night] = _.filter(data.assignments, (a) => {
            return a.space_id === space.id
          })
          array[index].placeholders = _.uniqBy(
            _.concat(
              array[index].placeholders,
              _.filter(data.placeholders, (p) => {
                return p.space_id === space.id
              })
            ),
            "id"
          )
        })
        this.dateDetails[night] = data.date_details
        if (night === this.lastDay) {
          this.setState({
            dateDetails: this.dateDetails,
            tableData: {
              nightRange: [this.firstDay, this.lastDay],
              spaces: this.spaces,
            },
          })
          setTimeout(() => {
            this.finishedDataFetch = true
            this.forceUpdate()
          }, 50)
          if (closure) {
            closure()
          }
        } else {
          this.getAssignmentsOnNight(
            closure,
            moment(night).add(1, "day").format("YYYY-MM-DD")
          )
        }
      }
    ).fail((data) => {
      this.setState({ errorLoadingData: data.responseJSON })
    })
  }

  lastUpdatedText() {
    this.setState({ pageLastUpdatedText: this.state.pageLastUpdated.fromNow() })
  }

  resetPageLastUpdated() {
    this.setState({ pageLastUpdated: moment() })
    afterSetState(this.lastUpdatedText)
  }

  getURLParameter(name) {
    return (
      decodeURIComponent(
        (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
          location.search
        ) || [null, ""])[1].replace(/\+/g, "%20")
      ) || null
    )
  }

  loadDate(night) {
    window.location =
      window.location.href.split("?")[0] +
      "?night=" +
      night.format("YYYY-MM-DD")
  }

  reloadPage() {
    window.location.reload(false)
  }

  editSpace(reservationID) {
    this.setState({
      editReservationID: reservationID,
      modalMinimized: false,
    })
  }

  enterSpace(reservationID) {
    this.setState({ hoveringReservation: reservationID })
  }

  leaveSpace(reservationID) {
    this.setState({ hoveringReservation: null })
  }

  enterPlaceholder(id) {
    this.setState({ hoveringPlaceholder: id })
  }

  leavePlaceholder() {
    this.setState({ hoveringPlaceholder: null })
  }

  hasNote(assignment, behind) {
    if (
      (assignment.note ||
        assignment.special_request ||
        assignment.contact_note) &&
      behind === false
    ) {
      return <i className="fa-solid fa-bell" />
    }
  }

  popoverData(assignment, behind) {
    if (behind === false) {
      let text = "<div class='text-center'>" + assignment.boat_name + "</div>"
      if (assignment.note) {
        text +=
          "<div class='bs-mt-2'><strong>Reservation Note:</strong> " +
          assignment.note +
          "</div>"
      }
      if (assignment.special_request) {
        text +=
          "<div class='bs-mt-2'><strong>Special Request:</strong> " +
          assignment.special_request +
          "</div>"
      }
      if (assignment.contact_note) {
        text +=
          "<div class='bs-mt-2'><strong>Contact Note:</strong> " +
          assignment.contact_note +
          "</div>"
      }
      return text
    }
  }

  newPlaceholder(id, name) {
    this.setState({ newPlaceholderForSpace: { id, name } })
  }

  editPlaceholder(placeholder, spaceName) {
    placeholder.space_name = spaceName
    this.setState({ editPlaceholder: placeholder })
  }

  hasLastDayAhead(i, l, space, dayString, id) {
    const day = moment(dayString)
    if (i + 1 === l) {
      // don't look forward
      return false
    }
    // check if there is an assignment ahead and does not have a conflict
    day.add(1, "days")
    return this.boatAssigned(space, day, id, (assign) => {
      return assign.last_day === true
    })
  }

  hasAhead(i, l, space, dayString, id) {
    const day = moment(dayString)
    if (i + 1 === l) {
      // don't look forward
      return false
    }
    // check if there is an assignment ahead and does not have a conflict
    day.add(1, "days")
    return this.boatAssigned(space, day, id)
  }

  hasBehind(i, l, space, dayString, id) {
    const day = moment(dayString)
    if (i === 0) {
      // don't look back
      return false
    }
    // check if there is an assignment ahead and does not have a conflict
    day.subtract(1, "days")
    return this.boatAssigned(space, day, id)
  }

  boatAssigned(space, day, id, predicate) {
    if (!predicate) {
      predicate = function () {
        return true
      }
    }

    let returnVal = false
    const assignments = space.assignments[day.format("YYYY-MM-DD")] || []
    assignments.forEach((assign) => {
      if (assign.encoded_id === id && predicate(assign)) {
        returnVal = true
      }
    })
    return returnVal
  }

  hasAssignmentConflict(assignments) {
    if (assignments.length < 2) {
      return false
    } else if (assignments.length > 2) {
      return true
    } else {
      let firstDay = false
      let lastDay = false
      for (let i = 0, l = assignments.length; i < l; i++) {
        if (assignments[i].last_day && assignments[i].first_day === false) {
          lastDay = true
        } else if (assignments[i].first_day) {
          firstDay = true
        }
      }
      return !(firstDay && lastDay)
    }
  }

  // whether there are at least 2 overlapping assignments or placeholders, excluding day trips
  // @param data is combined list of assignments and placeholders for a given day
  hasMultipleAssignmentsOrPlaceholders(data) {
    if (data.length < 2) {
      return false
    } else if (data.length > 2) {
      return true
    } else {
      let firstDay = false
      let lastDay = false
      for (let i = 0, l = data.length; i < l; i++) {
        // if it's not a day trip
        if (!this.isDayTrip(data[i])) {
          if (data[i].last_day && data[i].first_day === false) {
            lastDay = true
          } else if (data[i].first_day) {
            firstDay = true
          }
        }
      }
      return !(firstDay && lastDay)
    }
  }

  placeholdersAndAssignmentsForDay(dayString, placeholders, assignments) {
    const dayAssignments = assignments[dayString]

    const data = _.map(
      _.filter(placeholders, (placeholder) =>
        this.placeholderOnDay(placeholder, dayString)
      ),
      (placeholder) => {
        return {
          type: "placeholder",
          first_day: false,
          last_day: false,
          encoded_id: placeholder.id,
          ...placeholder,
        }
      }
    )

    return data.concat(
      _.map(dayAssignments, (assignment) => {
        return {
          type: "assignment",
          ...assignment,
        }
      })
    )
  }

  isDayTrip(assignment) {
    return assignment.last_day && assignment.first_day
  }

  placeholderOnDay(placeholder, dayString) {
    return (
      placeholder.start_date <= dayString && placeholder.end_date >= dayString
    )
  }

  stylingForReservationModal() {
    if (this.state.editReservationID !== false) {
      const style =
        "@media (min-width: 768px){.modal-open{overflow: auto;}.modal-backdrop.in {display: none;}}"
      return <style>{style}</style>
    }
  }

  mapRows() {
    const spaces = this.state.tableData.spaces
    const html = []
    for (let i = 0, l = spaces.length; i < l; i++) {
      html.push(<tr key={i}>{this.mapCells(spaces[i])}</tr>)
    }
    return html
  }

  onlyLastOrFirst(data) {
    return _.every(data, (thing) => {
      // not a day trip and only beginnings and ends.
      return !this.isDayTrip(thing) && (thing.first_day || thing.last_day)
    })
  }

  mapCells(space) {
    const html = [
      <td key="-1">
        <div
          className="add-placeholder"
          onClick={() => this.newPlaceholder(space.id, space.name)}
        >
          +
        </div>
        <span
          className="cursor-pointer"
          data-toggle="tooltip"
          data-placement="top"
          title={space.name}
        >
          {space.name}
        </span>
      </td>,
    ]
    const day = moment(this.state.tableData.nightRange[0]).subtract(1, "days")
    let dayString

    // keep a running tab of any conflicts over the space days (from oldest to newest).
    // Basically assigns an incrementing index (vertical position) to each relevant reservations.
    // --> we pull index out at render time to get reservation rows that are continuous.
    const verticalGroup = {}

    // such a thing
    for (let i = 0, l = this.daysInRange; i < l; i++) {
      dayString = day.add(1, "days").format("YYYY-MM-DD")

      const data = this.placeholdersAndAssignmentsForDay(
        dayString,
        space.placeholders,
        space.assignments
      )

      _.keys(verticalGroup).forEach((encodedId) => {
        if (!_.find(data, (d) => d.encoded_id === encodedId)) {
          delete verticalGroup[encodedId]
        }
      })

      // assign vertical index to any that doesn't have it
      data.forEach((placeOrAssign) => {
        if (!Object.hasOwn(verticalGroup, placeOrAssign.encoded_id)) {
          verticalGroup[placeOrAssign.encoded_id] = this.nextVerticalIndex(
            verticalGroup,
            data,
            placeOrAssign.first_day && !this.isDayTrip(placeOrAssign)
          )
        }
      })
      const maxGroupValue = _.max(_.values(verticalGroup))
      const maxVerticalIndex = isNaN(maxGroupValue) ? 1 : maxGroupValue + 1
      const assignments = _.filter(data, { type: "assignment" })
      const className = classNames("body-cell", {
        today: day.format("YYYY-MM-DD") === this.state.night,
        conflict: this.hasAssignmentConflict(assignments),
      })

      html.push(
        <td
          key={i}
          className={className}
          style={{ position: "relative", height: maxVerticalIndex * 38 + 5 }}
        >
          {this.spacePlaceholders(
            _.filter(data, { type: "placeholder" }),
            dayString,
            space.name,
            verticalGroup
          )}
          {this.spaceAssignments(
            assignments,
            i,
            l,
            space,
            dayString,
            verticalGroup
          )}
        </td>
      )
    }
    return html
  }

  spaceAssignments(assignments, topI, topL, space, dayString, verticalGroup) {
    const html = []
    let reservationID, ahead, behind, hasLastDayAhead

    for (let i = 0, l = assignments.length; i < l; i++) {
      reservationID = assignments[i].encoded_id
      ahead = this.hasAhead(
        topI,
        topL,
        space,
        dayString,
        assignments[i].encoded_id
      )
      behind = this.hasBehind(
        topI,
        topL,
        space,
        dayString,
        assignments[i].encoded_id
      )
      hasLastDayAhead = this.hasLastDayAhead(
        topI,
        topL,
        space,
        dayString,
        assignments[i].encoded_id
      )
      html.push(
        <div
          key={i}
          onClick={() => this.editSpace(reservationID)}
          onMouseEnter={() => this.enterSpace(reservationID)}
          onMouseLeave={() => this.leaveSpace(reservationID)}
          className={classNames(
            "assignment-cell",
            "assignment-status-" + assignments[i].status,
            {
              "assignment-hover":
                this.state.hoveringReservation === assignments[i].encoded_id,
              "assignment-selected":
                this.state.editReservationID === assignments[i].encoded_id &&
                this.state.modalMinimized === false,
              ahead,
              behind,
              "last-day-ahead": hasLastDayAhead,
              "first-day": assignments[i].first_day,
              "last-day": assignments[i].last_day,
            }
          )}
          data-content={this.popoverData(assignments[i], behind)}
          data-container="body"
          data-toggle="popover"
          data-placement="top"
          data-animation="false"
          data-html="true"
          style={{
            top: Object.hasOwn(verticalGroup, reservationID)
              ? verticalGroup[reservationID] * 37
              : 0,
          }}
        >
          {this.hasNote(assignments[i], behind)}
          {assignments[i].boat_name}
        </div>
      )
    }

    return html
  }

  spacePlaceholders(placeholders, dayString, spaceName, verticalGroup) {
    return _.map(placeholders, (placeholder) => {
      return (
        <div
          key={placeholder.id}
          onClick={() => this.editPlaceholder(placeholder, spaceName)}
          onMouseEnter={() => this.enterPlaceholder(placeholder.id)}
          onMouseLeave={() => this.leavePlaceholder()}
          className={classNames("placeholder-cell", {
            "placeholder-hover":
              this.state.hoveringPlaceholder === placeholder.id,
            "first-day": placeholder.start_date === dayString,
            "last-day": placeholder.end_date === dayString,
          })}
          data-content={placeholder.note}
          data-container="body"
          data-toggle="popover"
          data-placement="top"
          data-html="true"
          style={{
            top: Object.hasOwn(verticalGroup, placeholder.id)
              ? verticalGroup[placeholder.id] * 37
              : 0,
          }}
        >
          {placeholder.note}
        </div>
      )
    })
  }

  tableHeader() {
    if (
      moment(this.state.tableData.nightRange[0]).format("M") ===
      moment(this.state.tableData.nightRange[1]).format("M")
    ) {
      return (
        <thead>
          <tr>
            <th />
            <th colSpan={this.daysInRange}>
              {moment(this.state.tableData.nightRange[0]).format("MMMM YYYY")}
            </th>
          </tr>
          <tr>{this.tableHeaderDates()}</tr>
        </thead>
      )
    } else {
      return (
        <thead>
          <tr>
            <th />
            <th
              colSpan={
                Math.abs(
                  moment(this.state.tableData.nightRange[0])
                    .endOf("month")
                    .diff(moment(this.state.tableData.nightRange[0]), "days")
                ) + 1
              }
            >
              {moment(this.state.tableData.nightRange[0]).format("MMMM YYYY")}
            </th>
            <th
              colSpan={
                Math.abs(
                  moment(this.state.tableData.nightRange[1])
                    .startOf("month")
                    .diff(moment(this.state.tableData.nightRange[1]), "days")
                ) + 1
              }
            >
              {moment(this.state.tableData.nightRange[1]).format("MMMM YYYY")}
            </th>
          </tr>
          <tr>{this.tableHeaderDates()}</tr>
        </thead>
      )
    }
  }

  nextVerticalIndex(verticalGroup, data, isFirstDay) {
    let list
    let i

    if (isFirstDay) {
      const verticalGroupCopy = { ...verticalGroup }

      data.forEach((element) => {
        if (!this.isDayTrip(element) && element.last_day) {
          delete verticalGroupCopy[element.encoded_id]
        }
      })

      list = _.values(verticalGroupCopy)
    } else {
      list = _.values(verticalGroup)
    }

    const sorted = _.sortBy(_.uniqBy(list))

    // "smallest missing" algorithm
    for (i = 0; i < sorted.length; i++) {
      if (i !== sorted[i]) {
        return i
      }
    }

    return sorted.length
  }

  tableHeaderDates() {
    const html = [<th key="-1" />]
    const day = moment(this.state.tableData.nightRange[0])
    let totalBoats
    let assignedBoats
    for (let i = 0, l = this.daysInRange; i < l; i++) {
      assignedBoats =
        this.state.dateDetails[day.format("YYYY-MM-DD")].assigned_boats
      totalBoats = this.state.dateDetails[day.format("YYYY-MM-DD")].total_boats
      html.push(
        <th
          key={i}
          className={classNames({
            today: day.format("YYYY-MM-DD") === this.state.night,
          })}
        >
          {this.headerDateLink(day)}
          <br />
          <div
            className={classNames("label", {
              "badge-success": assignedBoats >= totalBoats,
              "badge-default": assignedBoats < totalBoats,
            })}
            data-content={
              assignedBoats +
              " assigned boats and " +
              totalBoats +
              " total boats."
            }
            data-container="body"
            data-toggle="popover"
            data-placement="top"
            data-html="true"
          >
            {assignedBoats} / {totalBoats}
          </div>
        </th>
      )
      day.add(1, "days")
    }
    return html
  }

  headerDateLink(day) {
    if (day.format("YYYY-MM-DD") === this.state.night) {
      return day.format("ddd, D")
    } else {
      return (
        <a
          href={
            "/manage/" +
            this.state.marinaSlug +
            "/assignments?night=" +
            day.format("YYYY-MM-DD")
          }
        >
          {day.format("ddd, D")}
        </a>
      )
    }
  }

  handleHideModal() {
    this.setState({ editReservationID: false })
  }

  handleHidePlaceholderModal() {
    this.setState({ newPlaceholderForSpace: null, editPlaceholder: null })
  }

  setGlobalState(object) {
    this.setState(object)
  }

  pendingAssignments() {
    const html = []
    const reservations = this.state.pendingAssignments
    for (let i = 0, l = reservations.length; i < l; i++) {
      const assignment = reservations[i]
      assignment.boat_name = boatDisplayText(
        assignment.contact_boat.name,
        inchesToFeet(assignment.contact_boat.length_overall),
        assignment.contact_boat.boat_type
      )
      html.push(
        <tr key={i}>
          <td className="shrink">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => this.editSpace(reservations[i].encoded_id)}
            >
              Assign
            </button>
          </td>
          <td className="occupied">{reservations[i].boat_name}</td>
          <td>{reservations[i].contact.name}</td>
          <td>
            {moment(
              reservations[i].check_in_date.substring(
                0,
                reservations[i].check_in_date.indexOf("T")
              )
            ).format("ddd Do, MMM YYYY")}
          </td>
          <td>
            {moment(
              reservations[i].check_out_date.substring(
                0,
                reservations[i].check_out_date.indexOf("T")
              )
            ).format("ddd Do, MMM YYYY")}
          </td>
        </tr>
      )
    }
    return html
  }

  pendingAssignmentsTable() {
    const unassignedCount = this.state.pendingAssignments.length
    if (unassignedCount > 0) {
      return (
        <div>
          <div className="pending-assignments paper-page table-responsive">
            <h3>
              {unassignedCount} Unassigned Reservation
              {unassignedCount !== 1 ? "s" : ""} on{" "}
              {moment(this.state.night).format("L")}
            </h3>
            <table className="table">
              <thead>
                <tr>
                  <th className="shrink" />
                  <th>Reservation</th>
                  <th>Captain</th>
                  <th>Arrival</th>
                  <th>Departure</th>
                </tr>
              </thead>
              <tbody>{this.pendingAssignments()}</tbody>
            </table>
          </div>
        </div>
      )
    }
  }

  initialLoad() {
    if (this.state.initialLoad) {
      setTimeout(() => {
        $(this.datePicker)
          .datepicker()
          .on("changeDate", (e) => {
            // set the state of the component to that of the datepicker
            this.loadDate(moment(this.datePicker.value, "L"))
          })
        setInterval(this.lastUpdatedText, 1000 * 60)
        this.setState({ initialLoad: false })
      }, 1000)
    }
  }

  renderPage() {
    this.initialLoad()
    return (
      <div className="assignments-react-controller">
        {this.stylingForReservationModal()}
        {this.state.editReservationID === false ? null : (
          <AssignModal
            state={this.state}
            resetPageLastUpdated={this.resetPageLastUpdated}
            handleHideModal={this.handleHideModal}
            setGlobalState={this.setGlobalState}
            loadPageData={this.loadPageData}
          />
        )}
        {this.state.newPlaceholderForSpace === null &&
        this.state.editPlaceholder === null ? null : (
          <PlaceholderModal
            state={this.state}
            handleHidePlaceholderModal={this.handleHidePlaceholderModal}
            controller={this}
            loadPageData={this.loadPageData}
          />
        )}
        {this.pendingAssignmentsTable()}
        <div className="datepicker-section">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() =>
              this.loadDate(moment(this.state.night).subtract(1, "days"))
            }
          >
            <i className="fa-solid fa-chevron-left" />
          </button>
          <div className="form-control-with-icon">
            <i className="fa-solid fa-calendar form-control-icon-left" />
            <input
              className="form-control datepicker"
              ref={this.setDatePicker}
              type="text"
              placeholder="mm/dd/yyyy"
              defaultValue={moment(this.state.night).format("L")}
              data-provide="datepicker"
              name="date"
              data-date-autoclose="true"
              data-date-disable-touch-keyboard="true"
            />
          </div>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() =>
              this.loadDate(moment(this.state.night).add(1, "days"))
            }
          >
            <i className="fa-solid fa-chevron-right" />
          </button>
        </div>
        <div className="row">
          <div className="col-sm-6 col-sm-offset-3">
            <ColorLegend />
          </div>
          <div className="col-sm-3">
            <div className="text-muted text-right" style={{ marginTop: 23 }}>
              Last updated {this.state.pageLastUpdatedText}.{" "}
              <a className="cursor-pointer" onClick={this.reloadPage}>
                refresh?
              </a>
            </div>
          </div>
        </div>
        <div className="table-responsive no-border">
          <table className="table-assigments table">
            {this.tableHeader()}
            <tbody>{this.mapRows()}</tbody>
          </table>
        </div>
      </div>
    )
  }

  renderLoading() {
    return (
      <div className="assignments-react-controller">
        <div className="loading-assignments bs-p-5">
          <h3 className="bs-mb-5 text-center">Loading assignments...</h3>
          <i className="fa-solid fa-spinner-third fa-spin" />
        </div>
      </div>
    )
  }

  renderFailedToLoad() {
    let message = "Error: " + this.state.errorLoadingData.error
    if (this.state.errorLoadingData.status === 500) {
      message = "An error occurred, please contact mayday@dockwa.com"
    }
    return (
      <div className="assignments-react-controller">
        <div className="loading-assignments bs-p-5">
          <h3 className="text-center">Error loading assignments</h3>
          <p className="bs-mb-3 text-center">{message}</p>
          <a className="btn btn-secondary center" onClick={this.reloadPage}>
            Retry
          </a>
        </div>
      </div>
    )
  }

  render() {
    if (isset(this.state.errorLoadingData)) {
      return this.renderFailedToLoad()
    } else {
      return (
        <div>
          {this.state.tableData && this.finishedDataFetch
            ? this.renderPage()
            : this.renderLoading()}
        </div>
      )
    }
  }
}

AssignmentsController.propTypes = {
  night: PropTypes.string.isRequired,
  marinaSlug: PropTypes.string.isRequired,
}

export default AssignmentsController
